export const backendPoint = process.env.REACT_APP_ADMIN_APP_GRAPHQL_ENDPOINT;
export const editUrl = process.env.REACT_APP_EDITOR_URL;
export const viewUrl = process.env.REACT_APP_VIEWER_URL;
export const imageUploadUrl = process.env.REACT_APP_IMAGE_UPLOAD_URL;
export const resourceUploadUrl = process.env.REACT_APP_RESOURCE_UPLOAD_URL;
export const landingPageUrl = process.env.REACT_APP_LOGIN_URL;
export const productViewerUrl = process.env.REACT_APP_PRODUCT_VIEWER_URL;
export const userpoolId = process.env.REACT_APP_USER_POOL_ID;
export const userpoolClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
export const cognitoRegionName = process.env.REACT_APP_COGNITO_REGION_NAME;
export const appDomain = process.env.REACT_APP_APP_DOMAIN;
export const videoUploadCSV = process.env.REACT_APP_VIDEO_UPLOAD_CSV;
export const s3Bucket = process.env.REACT_APP_S3_BUCKET;
export const worksheetId = process.env.REACT_APP_PUBLISHER_WORKSHEET_ID;
export const pk_12 = process.env.REACT_APP_PK_12;
export const refresh_url = process.env.REACT_APP_REFRESH_URL;
export const return_url = process.env.REACT_APP_RETURN_URL;
export const textTrackServiceURL = process.env.REACT_APP_TEXT_TRACK_SERVICE_URL;
export const textTrackServiceWebSocketURL = process.env.REACT_APP_TEXT_TRACK_SERVICE_WEBSOCKET_URL;
export const videoCreatorURL = process.env.REACT_APP_VIDEO_CREATOR_URL;
export const defaultPPTTheme = process.env.REACT_APP_DEFAULT_PPT_THEME;
export const edshopBuilderUrl = process.env.REACT_APP_EDSHOP_BUILDER_URL;
